// API适配器 - 将前端API调用适配到后端接口
import { apiService } from '@/services/api.service'

export const apiAdapter = {
  auth: {
    // 支持邮箱或用户名登录（后端 /auth/login 会按 email 或 username 匹配）
    async login(credentials: { email?: string; username?: string; password: string }) {
      return apiService.post('/auth/login', credentials)
    },

    async register(userData: {
      username: string
      email: string
      password: string
      nickname?: string
    }) {
      return apiService.post('/auth/register', userData)
    },

    async getProfile() {
      return apiService.get('/auth/profile')
    },

    async updateProfile(data: any) {
      return apiService.put('/auth/profile', data)
    },

    async logout() {
      // 前端清除token即可，后端无需特殊处理
      return Promise.resolve({ success: true })
    },

    async verify() {
      return apiService.get('/auth/verify')
    }
  },

  posts: {
    async getPosts(params: {
      page?: number
      limit?: number
      category?: string
      search?: string
      sort?: string
    }) {
      return apiService.get('/posts', { params })
    },

    async createPost(postData: {
      title: string
      content: string
      category?: string
      tags?: string[]
      images?: string[]
      isAnonymous?: boolean
    }) {
      return apiService.post('/posts', postData)
    },

    async getPost(id: string) {
      return apiService.get(`/posts/${id}`)
    },

    async updatePost(id: string, data: any) {
      return apiService.put(`/posts/${id}`, data)
    },

    async deletePost(id: string) {
      return apiService.delete(`/posts/${id}`)
    },

    async likePost(id: string) {
      return apiService.post(`/posts/${id}/like`)
    },

    async unlikePost(id: string) {
      // 同样的接口，后端会根据当前状态切换
      return apiService.post(`/posts/${id}/like`)
    },

    async searchPosts(query: string, params?: any) {
      return apiService.get('/posts/search', { 
        params: { q: query, ...params } 
      })
    },

    async getUserPosts(userId: string, params?: { page?: number; limit?: number }) {
      return apiService.get(`/posts/user/${userId}`, { params })
    }
  },

  comments: {
    async getComments(postId: string, params?: { page?: number; limit?: number }) {
      return apiService.get(`/comments/post/${postId}`, { params })
    },

    async createComment(data: {
      postId: string
      content: string
      parentCommentId?: string
      replyToUserId?: string
      isAnonymous?: boolean
    }) {
      return apiService.post(`/comments/post/${data.postId}`, {
        content: data.content,
        parentCommentId: data.parentCommentId,
        replyToUserId: data.replyToUserId,
        isAnonymous: data.isAnonymous
      })
    },

    async deleteComment(id: string) {
      return apiService.delete(`/comments/${id}`)
    },

    async likeComment(id: string) {
      return apiService.post(`/comments/${id}/like`)
    }
  },

  upload: {
    async uploadSingle(file: File) {
      const formData = new FormData()
      formData.append('image', file)
      return apiService.post('/upload/single', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    },

    async uploadMultiple(files: File[]) {
      const formData = new FormData()
      files.forEach(file => {
        formData.append('images', file)
      })
      return apiService.post('/upload/multiple', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    }
  },

  users: {
    async getUsers(params?: { page?: number; limit?: number }) {
      return apiService.get('/users', { params })
    },

    async getUser(id: string) {
      return apiService.get(`/users/${id}`)
    },

    async searchUsers(keyword: string) {
      return apiService.get(`/users/search/${keyword}`)
    }
  }
}

export default apiAdapter